export const MULTIPLE_TENANTS_COUNT = 2
